// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

import { GetChildAccountsInput, PaginationInput } from '@/gql/graphql';

const childAccountsKeys = {
  all: ['childAccounts'] as const,
  childAccounts: (
    input?: GetChildAccountsInput,
    pagination?: PaginationInput
  ) => {
    if (!input) {
      return [...childAccountsKeys.all, 'accounts'] as const;
    }
    if (!pagination) {
      return [...childAccountsKeys.all, 'accounts', input] as const;
    }
    return [...childAccountsKeys.all, 'accounts', input, pagination] as const;
  },
  childAccount: (accountId: string) =>
    [...childAccountsKeys.childAccounts(), accountId] as const,
};

export default childAccountsKeys;
